<template>
  <div class="c-survey-animation">
    <div class="timeline-1">
      <div
        class="timeline-1-animation-1"
        :class="[
          {
            'timeline-1-animation-1--up':
              currentScreenIndex > 0 && !disabledAnimationBackground,
          },
          {
            'timeline-1-animation-1--up-and-out':
              currentScreenIndex > 1 && !disabledAnimationBackground,
          },
        ]"
      >
        <lottie-vue-player
          :src="animationsURL + `HaveYourSay_Sky.json`"
          :player-controls="false"
          :loop="true"
          :autoplay="true"
        >
        </lottie-vue-player>
      </div>
      <div
        class="timeline-1-animation-2"
        :class="[
          {
            'timeline-1-animation-2--up':
              currentScreenIndex > 0 && !disabledAnimationBackground,
          },
          {
            'timeline-1-animation-2--up-and-out':
              currentScreenIndex > 1 && !disabledAnimationBackground,
          },
        ]"
      >
        <!-- prettier-ignore -->
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1489.79 507.48">
          <g id="Layer_1-2" data-name="Layer 1">
            <g>
              <path d="m1489.79,109.73v269.02h-923.18c10.16-32.95,33.94-79.58,77.96-145.57,29.4-44.07,64.1-85.06,104-119.98,23.88-20.9,56.66-51.18,88.85-56.8,15.22-2.65,30.04-.48,44.44-7.06,14.27-6.53,26.53-17.47,39.79-25.71,29.5-18.34,65.27-27.21,99.65-22.26,55.61,8,106.83,50.57,161.84,39.15,35.11-7.28,64.26-35.95,100.08-37.43,25.76-1.06,49.67,12.25,72,25.16,28.68,16.58,57.36,33.16,86.04,49.73,16.31,9.43,32.7,18.91,47.34,30.76.4.32.8.65,1.19,1Z" style="fill: #07774a; stroke-width: 0px;"/>
              <path d="m1489.79,368.88v138.6H0c64.74-177.7,129.28-231.25,153.24-243.53,37.69-19.33,78.08-39.28,121.35-37.2,40.54,1.95,77.9,23.21,118.5,23.74,74.38.97,126.83-64.42,194.54-92.26,51.96-21.36,112.72-19.66,167.54-5.28,27.93,7.33,54.61,17.72,80.51,29.71,24.93,11.52,49.13,24.54,73.04,37.71,43.2,23.81,91.65,49.4,141.18,40.04,26.29-4.96,49.5-19.47,75.88-24.07,55.93-9.74,107.67,26.17,151.68,58.87,44,32.71,98.86,66.4,153.47,51.75,7.18-1.92,14.31-4.69,21.78-4.45,15.04.49,26.03,12.52,34.84,23.55.75.94,1.5,1.88,2.24,2.82Z" style="fill: #09935e; stroke-width: 0px;"/>
            </g>
          </g>
        </svg>
      </div>

      <div
        class="timeline-1-animation-3"
        :class="[
          {
            'timeline-1-animation-3--up':
              currentScreenIndex > 0 && !disabledAnimationBackground,
          },
          {
            'timeline-1-animation-3--up-and-out':
              currentScreenIndex > 1 && !disabledAnimationBackground,
          },
        ]"
      >
        <lottie-vue-player
          :src="animationsURL + `HaveYourSay_City.json`"
          :player-controls="false"
          :loop="true"
          :autoplay="true"
        >
        </lottie-vue-player>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

// todo make he animation editable via upload

export default {
  data() {
    return {
      animationsURL: "/app/animations/survey-tool/",
    };
  },
  props: {},
  methods: {},
  computed: {
    ...mapFields(["currentScreenIndex", "disabledAnimationBackground"]),
  },
};
</script>

<style lang="scss">
.c-survey-animation {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.timeline-1 {
  background: linear-gradient(180deg, #2393ff 0%, #0ff 99.99%, #0ff 100%);
  height: 100%;
}
//animation 1 is a 3 screen tall paralax animation
.timeline-1-animation-1 {
  position: absolute;
  display: flex;
  align-items: flex-start;
  height: 100vh;
  transition: all 3.5s ease;
  width: 100%;
  &--up {
    transform: translateY(-30%);
  }
  &--up-and-out {
    transform: translateY(-100%);
  }
}
.timeline-1-animation-2 {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(50%);
  transition: all 2.5s ease;
  width: 100%;
  &--up {
    transform: translateY(-20%);
  }
  &--up-and-out {
    transform: translateY(-100%);
  }
  svg {
    width: 100%;
    height: auto;
  }
}

.timeline-1-animation-3 {
  position: absolute;
  display: flex;
  align-items: flex-end;
  height: 100vh;
  // transition: all 2.5s ease;
  transform: translateY(100%);
  width: 100%;
  &--up {
    // transform: translateY(0%);
  }
  &--up-and-out {
    // transform: translateY(-100%);
  }
}
</style>
